import { Metrics } from '../../../constants/Dashboards'
import { ActionsTypes } from '../../types'
import generateActionTypes from '../generateActionTypes'

const eventSpace2: Metrics[] = [
    Metrics.EVENTSPACE2_STORES_TOP,
    Metrics.EVENTSPACE2_INTERACTIONS_GROUPED,
    Metrics.EVENTSPACE2_DWELLTIMELINE,
    Metrics.EVENTSPACE2_CONTENT_TOP,
    Metrics.EVENTSPACE2_DEVICES_ONLINE,
]

const actionTypes: ActionsTypes = generateActionTypes(eventSpace2)

export type ArkActionTypes = typeof actionTypes

export default actionTypes
